import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ENTITY_MODE } from '../../../shared/typings/types/entity-mode.types';
import { Observable, of } from 'rxjs';
import { SUPPORTED_ENTITY_TYPES } from '../../url-matchers/entity-type-matcher/entity-type-matcher';
import { ENTITY_TYPE } from 'Src/ng2/shared/typings/types/entity-type.types';

@Injectable({
  providedIn: 'root',
})
export class EntityIdFirstRedirectGuard implements CanActivate {
  constructor (private router: Router) {}

  canActivate (_routeSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree | boolean> {
    const parsedTree = this.router.parseUrl(state.url);
    const primaryGroup = parsedTree.root.children.primary;
    if (!primaryGroup?.segments?.length) return of(false);

    const paths = primaryGroup.segments.map(s => s.path);
    // expect: [district, entityType, entityMode-or-entityId, ...]
    if (paths.length < 3) return of(false);

    const entityType = paths[1] as ENTITY_TYPE;
    if (!SUPPORTED_ENTITY_TYPES.includes(entityType)) return of(false);

    const thirdSegment = paths[2];
    if (thirdSegment === ENTITY_MODE.SINGLE_ENTITY_URL_PREFIX || thirdSegment === ENTITY_MODE.MULTI_ENTITY_URL_PREFIX) return of(false);

    paths.splice(2, 0, ENTITY_MODE.SINGLE_ENTITY_URL_PREFIX);

    return of(this.router.createUrlTree(paths, {
      queryParams: parsedTree.queryParams,
      fragment: parsedTree.fragment,
    }));
  }
}
